module.exports = __webpack_public_path__ + "static/media/condividi.832e9393.svg";